module.exports = __webpack_public_path__ + "static/media/tiger_v2.ee148581.jpg";